<div class="table-responsive">
  <table class="table m-0 amm-table-striped table-bordered">
    <thead>
      <tr>
        @for (header of data.headers; track header) {
          <th
            class="amm-header"
            [class]="header.color"
            scope="col"
            >
            {{ header.title }}
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of data.data; track row) {
        <tr>
          @for (col of row; track col) {
            <td
              class="amm-cols"
              [ngClass]="col.currency ? 'text-end' : 'text-start'"
              >
              {{ col.currency ? (+col.content | currency) : col.content }}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
@if (data.footer) {
  <div
    class="pt-3"
    [innerHTML]="data.footer"
    style="font-size: 11px"
  ></div>
}
